import React from 'react';
import { Button } from '@asigna/kit';
import cx from 'classnames';

import { title1Icon, title2Icon, title3Icon } from './util/images';

import s from './index.module.scss';

interface NewsSlideProps {
  title: string;
  description: string;
  link: string;
  btnTitle?: string;
  index?: number;
}

export const NewsSlide: React.FC<NewsSlideProps> = (props) => {
  const { title, description, link, index, btnTitle = 'Read more' } = props;

  return (
    <div
      className={cx(
        'p-20 sm:p-32 rounded-[16px] bg-white-30 relative',
        s[`slide${index !== undefined ? index % 3 : 1}`]
      )}
    >
      <div className="flex flex-col md:flex-row items-center gap-8 min-h-[228px] sm:min-h-[120px] justify-evenly">
        <div className="flex flex-col gap-16 basis-2/3 text-white">
          <div className="flex items-center gap-12">
            {index && (
              <img
                src={index % 3 === 0 ? title1Icon : index % 3 === 1 ? title2Icon : title3Icon}
                alt=""
              />
            )}
            <p className="font-bold text-[22px] leading-[32px] italic">{title}</p>
          </div>
          <p className="text-r14 min-h-48">{description}</p>
        </div>
        <div className="flex basis-1/3 self-start sm:self-center sm:justify-end">
          <Button
            message={btnTitle}
            colorType="white"
            fontColor="black-0"
            size="md"
            onClick={() => window.open(link, '_blank')}
            className="z-10 min-w-[148px]"
          />
        </div>
      </div>
    </div>
  );
};
